import styled from "@emotion/styled";
import { ListBoxItem } from "react-aria-components";

type StyledListBoxItemProps = {
  onAction?: () => void;
};

export const StyledListBoxItem = styled(ListBoxItem)<StyledListBoxItemProps>`
  display: flex;
  max-width: 784px;
  padding: ${({ theme }) => theme.spacing[4]} ${({ theme }) => theme.spacing[3]};
  justify-content: space-between;
  align-items: center;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  background: ${({ theme }) => theme.colors.surface.pane};
  gap: ${({ theme }) => theme.spacing[3]};

  outline: none;

  ${({ onAction, theme }) =>
    !!onAction &&
    `
    user-select: none;
    cursor: pointer;

    &[data-focused] {
      background-color: ${theme.colors.grey.x50};
    }

    &[data-selected] {
      background-color: ${theme.colors.mblue.x50};
    }

    &:hover:not([data-disabled]) {
      background-color: ${theme.colors.grey.x50};
    }
  `}

  &[data-disabled] {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const StyledItemContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  justify-content: center;
  align-self: stretch;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing[1]};
`;

export const StyledIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.grey.x50};
  color: ${({ theme }) => theme.colors.grey.x500};
`;

export const StyledRightAddon = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs};
`;

export const StyledAddItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  color: ${({ theme }) => theme.colors.mblue.x500};
  font-weight: 500;
`;
